import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-page-content',
  templateUrl: './horizontal-page-content.component.html',
  styleUrls: ['./horizontal-page-content.component.scss'],
})
export class HorizontalPageContentComponent {
}
